import Swiper, {
    Navigation, Pagination, EffectFade
} from 'swiper';

const breakpoints = {
    mobile: 768,
    tablet: 979,
    desktop: 1200
};

/**
 * собирает массив номеров слайдов без кнопок
 * @param heroSlider {Object} - слайдер
 * @returns {*[]}
 */
function collectSLideWithOutButton(heroSlider) {
    const slideArray = [];
    for (let i = 0; i < heroSlider.slides.length; i++) {
        const el = heroSlider.slides[i];
        const button = el.querySelector('.m-main-banner__button');
        if (!button) {
            slideArray.push(i);
        }
    }
    return slideArray;
}

/**
 * установка стилей в контейнер пагинации
 * @param targetSlides {Array} - массив с номерами слайдов без кнопок
 * @param heroSlider {Object} - слайдер
 * @param paginationContainer {HTMLElement} - контейнер
 * @returns {boolean}
 */
function setStyleToContainer(targetSlides, heroSlider, paginationContainer) {
    if (window.innerWidth > breakpoints.tablet) {
        const container = paginationContainer;
        let containerPositionLeft = '0';
        for (let i = 0; i < heroSlider.slides.length; i++) {
            if (targetSlides.includes(heroSlider.realIndex + 1)) {
                containerPositionLeft = document.querySelector('.m-main-banner__content')?.getBoundingClientRect().left;
                container.style.left = `${containerPositionLeft}px`;
            } else {
                const buttonPositionLeft = document.querySelector('.m-main-banner__button')?.getBoundingClientRect().left;
                const buttonWidth = document.querySelector('.m-main-banner__button')?.getBoundingClientRect().width;
                containerPositionLeft = `${buttonPositionLeft + buttonWidth + 60}`;
                container.style.left = `${containerPositionLeft}px`;
            }
        }
    }
}

export function swiperHeroBanner() {
    Swiper.use([Navigation, Pagination, EffectFade]);
    // eslint-disable-next-line no-new
    const heroSlider = new Swiper('#main-swiper', {
        loop: true,
        fadeEffect: { crossFade: true },
        effect: 'fade',
        spaceBetween: 32,
        speed: 1000,
        slidesPerView: 1,
        navigation: {
            nextEl: '.m-main-swiper-button-next',
            prevEl: '.m-main-swiper-button-prev',
        },
        pagination: {
            el: '.m-swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });
    const paginationContainer = document.querySelector('.m-swiper-pagination-container');
    if (!paginationContainer) {
        return false;
    }

    new ResizeObserver(() => {
        setStyleToContainer(collectSLideWithOutButton(heroSlider), heroSlider, paginationContainer);
    }).observe(document.body);

    heroSlider.on('activeIndexChange', () => {
        setStyleToContainer(collectSLideWithOutButton(heroSlider), heroSlider, paginationContainer);
    });
}

export function swiperDataSupport() {
    Swiper.use([Navigation, Pagination]);
    // eslint-disable-next-line no-new
    new Swiper('#system-support-swiper', {
        slidesPerView: 1.6,
        spaceBetween: 24,
        navigation: {
            nextEl: '.m-system-support__btn-next',
            prevEl: '.m-system-support__btn-prev',
            disabledClass: 'is-disabled'
        },
        pagination: {
            el: '.m-system-support__pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            1200: {
                slidesPerView: 1.6,
                spaceBetween: 24
            },
            768: {
                slidesPerView: 1.15,
                spaceBetween: 24
            },
            320: {
                slidesPerView: 1.03,
                spaceBetween: 8
            }
        }
    });
}

export function swiperDataBenefits() {
    Swiper.use([Navigation, Pagination]);

    if (window.innerWidth < breakpoints.mobile) {
        // eslint-disable-next-line no-new
        new Swiper('#system-benefits-swiper', {
            slidesPerView: 1.6,
            spaceBetween: 24,
            navigation: {
                nextEl: '.m-system-benefits__btn-next',
                prevEl: '.m-system-benefits__btn-prev',
                disabledClass: 'is-disabled'
            },
            pagination: {
                el: '.m-system-benefits__pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1200: {
                    slidesPerView: 1.6,
                    spaceBetween: 24
                },
                768: {
                    slidesPerView: 1.15,
                    spaceBetween: 24
                },
                320: {
                    slidesPerView: 1.03,
                    spaceBetween: 8
                }
            }
        });
    }
}

export function swiperDataIndustries() {
    Swiper.use([Navigation, Pagination]);

    if (window.innerWidth < breakpoints.mobile) {
        // eslint-disable-next-line no-new
        new Swiper('#system-industries-swiper', {
            slidesPerView: 1.6,
            spaceBetween: 24,
            navigation: {
                nextEl: '.m-system-industries__btn-next',
                prevEl: '.m-system-industries__btn-prev',
                disabledClass: 'is-disabled'
            },
            pagination: {
                el: '.m-system-industries__pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1200: {
                    slidesPerView: 1.6,
                    spaceBetween: 24
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 24
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 8
                }
            }
        });
    }
}

export function swiperFeedback() {
    Swiper.use([Navigation]);
    // eslint-disable-next-line no-new
    new Swiper('#feedback-swiper', {
        slidesPerView: 1.16,
        spaceBetween: 10,
        navigation: {
            nextEl: '.m-swiper-button-next',
            prevEl: '.m-swiper-button-prev',
            disabledClass: 'is-disabled'
        },
        breakpoints: {
            1200: {
                slidesPerView: 3,
                spaceBetween: 50
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            380: {
                slidesPerView: 1.85,
                spaceBetween: 16
            },
        }
    });
}

export function swiperTeam() {
    // eslint-disable-next-line no-new
    new Swiper('#team-swiper', {
        slidesPerView: 1.4,
        spaceBetween: 16,
        breakpoints: {
            1200: {
                slidesPerView: 4,
                spaceBetween: 22
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            480: {
                slidesPerView: 2.5,
                spaceBetween: 16
            },
            361: {
                slidesPerView: 1.8,
                spaceBetween: 16
            },
            340: {
                slidesPerView: 1.5,
                spaceBetween: 16
            },
        }
    });
}

export function swiperPhotoGallery() {
    const photoGalleryRow = document.querySelectorAll('.js-photo-gallery');
    if (!photoGalleryRow) {
        return false;
    }
    photoGalleryRow.forEach((el) => {
        // eslint-disable-next-line no-new
        new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            breakpoints: {
                1200: {
                    spaceBetween: 24
                }
            }
        });
    });
}
